module.exports = __webpack_public_path__ + "static/media/appGallery.a2fe729d.svg";